{
  "page_title": "Your Profile",
  "profile": {
    "title": "Profile",
    "personal_information": "Profile",
    "account_information": "Account",
    "notifications": "Notifications",
    "change_password": "Security",
    "delete_account": "Delete account",
    "address_form_title": "Address",
    "general_form_title": "General Information",
    "page": {
      "personal_information": {
        "title": "Personal Information",
        "section_info": "General:",
        "section_address": "Address:",
        "update_success": "Profile updated successfully",
        "edit": "Editing..."
      }
    },
    "error": {
      "invalid_credentials": "Invalid current password",
      "duplicate_email": "Email address already registered"
    },
    "unsaved_form_question": "Your changes are not saved. Are you sure?",
    "label": {
      "first_name": "First Name",
      "middle_name": "Middle Name",
      "last_name": "Last Name",
      "email_address": "Email address",
      "country_code": "Country Code",
      "phone_number": "Phone Number",
      "address_line_1": "Address Line 1",
      "address_line_2": "Address Line 2",
      "address_line_3": "Address Line 3",
      "postal_code": "ZIP / Postal Code",
      "city": "City",
      "state": "State",
      "country": "Country",
      "current_password": "Current password",
      "new_password": "New password",
      "verify_password": "Verify password",
      "language": "Language"
    },
    "language": {
      "en": "English",
      "de": "German"
    },
    "buttons": {
      "submit_form": "Save changes",
      "cancel_form": "Cancel"
    },
    "validation": {
      "_common": {
        "trailing_whitespace": "Remove trailing whitespace",
        "beginning_whitespace": "Remove beginning whitespace"
      },
      "firstName": {
        "empty": "First Name is required",
        "trailing_whitespace": "$t(profile.validation._common.trailing_whitespace)",
        "beginning_whitespace": "$t(profile.validation._common.beginning_whitespace)"
      },
      "middleName": {
        "trailing_whitespace": "$t(profile.validation._common.trailing_whitespace)",
        "beginning_whitespace": "$t(profile.validation._common.beginning_whitespace)"
      },
      "lastName": {
        "empty": "Last Name is required",
        "trailing_whitespace": "$t(profile.validation._common.trailing_whitespace)",
        "beginning_whitespace": "$t(profile.validation._common.beginning_whitespace)"
      },
      "email": {
        "empty": "Email Address is required",
        "duplicate_email": "Email address already registered",
        "invalid_email": "Enter a valid email",
        "trailing_whitespace": "$t(profile.validation._common.trailing_whitespace)",
        "beginning_whitespace": "$t(profile.validation._common.beginning_whitespace)"
      },
      "phoneNationalNumber": {
        "invalid_number_string": "Enter valid phone number",
        "min_digits": "{{country}} phone numbers must be at least {{min}} digits",
        "max_digits": "{{country}} phone numbers must be at most {{max}} digits",
        "exact_digits": "{{country}} phone numbers must be exactly {{min}} digits",
        "trailing_whitespace": "$t(profile.validation._common.trailing_whitespace)",
        "beginning_whitespace": "$t(profile.validation._common.beginning_whitespace)"
      },
      "phoneCountryCode": {
        "empty": "Country Code is required"
      },
      "oldPassword": {
        "empty": "Enter your current password",
        "invalid_password": "Password must contain at least 8 characters, one uppercase letter, one lowercase letter and a digit"
      },
      "newPassword": {
        "empty": "Enter new password",
        "invalid_password": "Password must contain at least 8 characters, one uppercase letter, one lowercase letter and a digit"
      },
      "newPasswordConfirm": {
        "empty": "Repeat new password",
        "no_match": "Passwords do not match"
      },
      "address": {
        "line1": {
          "empty": "Address Line 1 is required",
          "trailing_whitespace": "$t(profile.validation._common.trailing_whitespace)",
          "beginning_whitespace": "$t(profile.validation._common.beginning_whitespace)"
        },
        "line2": {
          "trailing_whitespace": "$t(profile.validation._common.trailing_whitespace)",
          "beginning_whitespace": "$t(profile.validation._common.beginning_whitespace)"
        },
        "line3": {
          "trailing_whitespace": "$t(profile.validation._common.trailing_whitespace)",
          "beginning_whitespace": "$t(profile.validation._common.beginning_whitespace)"
        },
        "postalCode": {
          "empty": "ZIP / Postal Code is required",
          "trailing_whitespace": "$t(profile.validation._common.trailing_whitespace)",
          "beginning_whitespace": "$t(profile.validation._common.beginning_whitespace)"
        },
        "city": {
          "empty": "City is required",
          "trailing_whitespace": "$t(profile.validation._common.trailing_whitespace)",
          "beginning_whitespace": "$t(profile.validation._common.beginning_whitespace)"
        },
        "state": {
          "empty": "State is required",
          "trailing_whitespace": "$t(profile.validation._common.trailing_whitespace)",
          "beginning_whitespace": "$t(profile.validation._common.beginning_whitespace)"
        },
        "countryCode": {
          "empty": "Country is required"
        }
      }
    }
  },
  "organizations": {
    "title": "Organizations",
    "submenu": {
      "title": "My Organizations",
      "create": "Create",
      "assigned_organizations": "Assigned Organizations",
      "empty": "No organization yet"
    },
    "page": {
      "empty": {
        "title": "No organizations yet",
        "subtitle": "Create an organization",
        "body": "Here you can view and manage your organizations and those to which you have been assigned.<br><hr><br> To create an organization, please press the create button to the top right."
      },
      "select": {
        "title": "Organization Information",
        "subtitle": "",
        "body": "Select an Organization to see details"
      },
      "header": {
        "title": "{{organization}}",
        "subtitle": "Role:",
        "admin_action": "Admin",
        "edit": "editing...",
        "details": "General:",
        "address": "Address:"
      }
    },
    "modal": {
      "message": "Are you sure you want to leave {{organizationName}}?",
      "leave": "Leave",
      "cancel": "Cancel"
    }
  },
  "notifications": {
    "screen_title": "Choose how you receive notifications",
    "group_name": {
      "first_party_clusters": "1st party clusters",
      "first_party_clusters_tooltip": "Clusters created by the current user",
      "second_party_clusters": "2nd party clusters",
      "second_party_clusters_tooltip": "Clusters created inside an organization the user belongs to"
    },
    "notification_type": {
      "web_and_mobile": "Web & Mobile",
      "email": "Email"
    },
    "label": {
      "changes_saved": "Changes saved",
      "receive_notifications": "Receive notifications"
    },
    "notification_name": {
      "cluster_created": "Cluster created",
      "cluster_updated": "Cluster updated",
      "cluster_deleted": "Cluster deleted",
      "cluster_unavailable": "Cluster unavailable"
    }
  },
  "invitations": {
    "title": "Invitations",
    "list_heading": "My Invitations",
    "no_invitations": "No pending invitations",
    "page": {
      "empty": {
        "title": "No Invitations",
        "subtitle": "",
        "body": "You have no pending invitations."
      },
      "select": {
        "title": "You have pending invitations",
        "subtitle": "",
        "body": "Select an invitation to see the details of the organization"
      },
      "header": {
        "title": "{{organization}}",
        "subtitle": "",
        "form_section_details": "Details:",
        "form_section_address": "Address:",
        "get_organization_error": "The organization was not found",
        "error_submit": "An error has occurred: Your invitation cannot be resolved",
        "modal_title": "Pending Invitation",
        "modal_content_text": "Resolving Invite to: ",
        "modal_content_textaccept": "Are you sure that you want to accept the invitation and join the organization?",
        "modal_content_textreject": "Are you sure that you want to reject the invitation?"
      }
    },
    "label": {
      "you_are_invited_to": "You’re Invited to",
      "invited_by": "Invited By",
      "your_organizations": "Your Organizations",
      "role": "Role"
    }
  },
  "delete_account": {
    "title": "Delete account",
    "warning": "Once you delete your account, there is no going back. Please be certain.",
    "button_text": "Delete your account"
  },
  "delete_image": {
    "title": "Delete image",
    "confirm_delete_image": "Are you sure that you want to delete your profile image?"
  }
}
